import { render, staticRenderFns } from "./shipmentStaffAdd.vue?vue&type=template&id=aea80358&scoped=true"
import script from "./shipmentStaffAdd.vue?vue&type=script&lang=js"
export * from "./shipmentStaffAdd.vue?vue&type=script&lang=js"
import style0 from "./shipmentStaffAdd.vue?vue&type=style&index=0&id=aea80358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea80358",
  null
  
)

export default component.exports